import { gql } from 'graphql-tag'

export const FRAGMENT_CONVERSATION_MENU_CONVERSATION = gql`
  fragment ConversationMenuConversation on conversation {
    id
    type

    current_conversation_user: conversation_users(where: { user_id: { _eq: $currentUserId } }) {
      archived_at
      last_read_at
    }
    last_message: messages(order_by: { created_at: desc }, limit: 1) {
      created_at
    }
    conversation_users {
      user {
        id
        username
      }
    }
    series {
      id
    }
    session {
      id
    }
  }
`
